<div class="page-wrapper">
<HomeNavBar />
<InactivityModal />
<div v-if="is_loading" class="text-center py-5 w-100">
  <div class="spinner-border text-secondary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <p class="mt-2 mb-0 text-muted">Loading</p>
</div>

<div v-else>
  <div class="mx-3">
      <div class="card rounded px-4 py-3">
      <div class="d-flex align-items-start justify-content-between flex-wrap gap-3">
        <div class="d-flex align-items-start gap-3 flex-grow-1 min-w-0">
        <div class="min-w-0">
          <span
            class="text-muted small cursor-pointer d-flex align-items-center gap-1"
            @click="back"
          >
            <i class="bi bi-arrow-left"></i>
            Back
          </span>
          <h1 class="fw-bolder mb-1 text-primary">{{ event?.event_name }}</h1>
          <p class="text-xxs text-muted mb-1">
            Organised by <span class="fw-bold text-dark">{{ event?.organizer }}</span>
            <span class="mx-2">&bull;</span>
            {{ event?.location }}
          </p>
          <p class="d-flex align-items-center gap-1 text-muted text-xxs mb-0">
            <i class="bi bi-calendar3 text-secondary"></i>
            {{ event_date_line }}
          </p>
          <div v-if="can_edit" class="d-flex flex-wrap gap-2 mt-3 d-none">
            <button
              type="button"
              class="btn btn-sm btn-primary rounded text-xxs fw-semibold"
              @click.stop="open_add_speakers(event)"
            >
              <i class="bi bi-person-plus-fill me-1"></i>
              Add Speakers
            </button>
            <button
              type="button"
              class="btn btn-sm btn-primary rounded text-xxs fw-semibold"
              @click.stop="open_add_sponsors(event)"
            >
              <i class="bi bi-award me-1"></i>
              Sponsors
            </button>
            <button
              v-if="!event?.is_free"
              type="button"
              class="btn btn-sm btn-primary rounded text-xxs fw-semibold"
              @click.stop="open_promo_code_manager(event)"
            >
              <i class="bi bi-ticket-detailed-fill me-1"></i>
              Promo Codes
            </button>
            <button
              type="button"
              class="btn btn-sm btn-primary rounded text-xxs fw-semibold"
              @click.stop="open_media_gallery(event)"
            >
              <i class="bi bi-images me-1"></i>
              Media Gallery
            </button>
            <button
              type="button"
              class="btn btn-sm btn-primary rounded text-xxs fw-semibold"
              @click.stop="open_document_upload(event)"
            >
              <i class="bi bi-file-earmark-arrow-up me-1"></i>
              Upload Docs
            </button>
            <button
              type="button"
              class="btn btn-sm btn-primary rounded text-xxs fw-semibold"
              @click.stop="open_agenda_create(event)"
            >
              <i class="bi bi-clipboard-check me-1"></i>
              Agenda
            </button>
            <button
              type="button"
              class="btn btn-sm btn-primary rounded text-xxs fw-semibold"
              @click.stop="open_create_survey(event)"
              v-if="!event.survey.length"
            >
              <i class="bi-card-checklist me-1"></i>
              Create Survey
            </button>
          </div>
        </div>
        </div>
        <div
          v-if="event?.promo_codes?.length && is_promo_valid(event?.promo_codes[0]?.valid_start_date, event?.promo_codes[0]?.valid_end_date)"
          class="position-relative d-inline-flex align-items-center justify-content-center text-xxxs promo-tag cursor-pointer"
          @click.stop="open_promo_code_modal(event)"
        >
          <i class="bi bi-tag-fill text-primary"></i>
          <span class="position-absolute text-xxxs text-white text-align-center h-1 centered-promo-tag">
            PROMO CODE
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="scrollable-container pb-5">
    <div class="mx-3 ">
      <div class="row g-2 mt-1">
        <div class="col-lg-8 order-1 order-lg-0 mb-5">
          <div>
            <!--Event details-->
            <div class="card rounded px-4 py-3">
              <div class="d-flex align-items-center gap-2 mb-2">
                <div class="d-flex align-items-center justify-content-center rounded-2 text-secondary ">
                  <i class="bi bi-clipboard2-check"></i>
                </div>
                <div class="event-details-title text-dark fw-bold">Event details</div>
              </div>
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="bg-light rounded h-100 d-flex align-items-center p-3 gap-2">
                    <div class="d-flex align-items-center justify-content-center border bg-white text-secondary flex-shrink-0 rounded ai-agent-icon">
                      <i class="bi bi-calendar-event"></i>
                    </div>
                    <div>
                      <div class="mb-1 text-secondary fw-bold text-xxs text-uppercase">Date</div>
                      <div class="fw-bold text-xxs">{{ format_date(event?.start_date) }} - {{ format_date(event?.end_date) }}</div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="bg-light rounded p-3 d-flex align-items-center gap-2 h-100">
                    <div class="d-flex align-items-center justify-content-center border bg-white  text-secondary flex-shrink-0 rounded ai-agent-icon">
                      <i class="bi bi-clock"></i>
                    </div>
                    <div>
                      <div class="mb-1 text-secondary fw-bold text-xxs text-uppercase">Time</div>
                      <div class="fw-bold text-xxs">
                        {{ form_time(event?.start_time) || 'Not set' }}
                        <span v-if="event?.end_time">- {{ form_time(event?.end_time) }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                <div class="bg-light rounded p-3 d-flex align-items-start gap-3 h-100">
                  <div class="d-flex align-items-center justify-content-center border bg-white text-secondary  flex-shrink-0 rounded ai-agent-icon">
                    <i class="bi" :class="event?.event_type?.name === 'online' ? 'bi-laptop' : 'bi-geo-alt'"></i>
                  </div>

                  <div class="flex-grow-1">
                    <div class="row g-2 align-items-start">
                      <div v-if="event?.event_type?.name !== 'online'" class="col-12" :class="event?.event_type?.name === 'hybrid' ? 'col-md-7' : ''">
                        <div class="mb-1 text-secondary fw-bold text-xxs text-uppercase">
                          {{ event?.event_type?.name === 'hybrid' ? 'Physical Location' : 'Location' }}
                        </div>
                        <div class="fw-bold text-xxs text-wrap text-break">
                          {{event?.location}}
                        </div>
                      </div>

                      <div
                        v-if="event?.event_type?.name === 'online' || event?.event_type?.name === 'hybrid'"
                        class="col-12 mt-2 mt-md-0"
                        :class="event?.event_type?.name === 'hybrid' ? 'col-md-5' : ''"
                      >
                        <div v-if="event?.event_type?.name === 'hybrid'" class="d-md-none border-top w-100"></div>
                        <div class="d-flex align-items-start" :class="event?.event_type?.name === 'hybrid' ? 'pt-2 pt-md-0' : ''">
                          <div v-if="event?.event_type?.name === 'hybrid'" class="d-none d-md-block border-start me-3"></div>
                          <div class="flex-grow-1">
                            <div class="mb-1 text-secondary fw-bold text-xxs text-uppercase">Join Online</div>
                            <a :href="event?.event_link" target="_blank" class="fw-bold text-xxs text-blue text-decoration-none">
                              Meeting Link <i class="bi bi-box-arrow-up-right ms-1"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

                <div class="col-md-6">
                  <div class="bg-light rounded p-3 d-flex align-items-center gap-2 h-100">
                    <div class="d-flex align-items-center justify-content-center border bg-white text-secondary flex-shrink-0 rounded ai-agent-icon">
                      <i class="bi bi-people"></i>
                    </div>
                    <div>
                      <div class="mb-1 text-secondary fw-bold text-xxs text-uppercase">Capacity</div>
                      <div class="fw-bold text-xxs">{{ capacity_value ? capacity_value + ' attendees' : 'Maximum' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Description Card-->
            <div class="card rounded p-3 mt-2 shadow-sm" v-if="check_description(event?.description)">
              <h6 class="d-flex fw-bold align-content-center justify-content-center text-primary mb-2">About this event</h6>
              <div v-if="check_description(event?.description)" class="description-body text-xxs text-muted">
                <div v-if="show_full_description" v-html="event.description"></div>
                <div v-else>{{ truncated_description }}</div>
              </div>
              <p v-else class="text-muted text-xxxs mb-0">No description provided.</p>
              <button
                v-if="has_long_description"
                class="btn btn-link btn-sm mt-2 fw-bold fst-italic text-xxs p-0 shadow-none"
                type="button"
                @click="toggle_description"
              >
                {{ show_full_description ? 'See less' : 'See more' }}
              </button>
            </div>
            <!-- Agenda Card -->
            <div class="card rounded p-3 mt-2 shadow-sm" v-if="has_agenda(event)">
              <button
                type="button"
                class="btn btn-link p-0 text-decoration-none text-start w-100"
                @click="view_agenda(event)"
              >
                <div class="d-flex align-items-center justify-content-between gap-3">
                  <div class="d-flex align-items-center gap-2">
                    <div class="d-flex align-items-center justify-content-center text-bg-secondary">
                      <i class="bi bi-list-check"></i>
                    </div>
                    <div class="fw-bold text-dark">Agenda</div>
                  </div>
                   <div class="btn btn-sm btn-primary text-xxs rounded px-3 py-1">
                    See More
                  </div>
                </div>

                <div v-if="event?.agenda?.length" class="mt-3 d-flex flex-column gap-2">
                  <div
                    v-for="item in event.agenda.slice(0, 3)"
                    :key="item.id || item.description"
                    class="d-flex align-items-center gap-3 bg-light rounded-3 px-3 py-2"
                  >
                    <div class="text-center flex-shrink-0">
                      <div class="fw-bold text-dark text-xxs">{{ form_time(item.start_time) }} - {{ form_time(item.end_time) }}</div>
                    </div>
                    <div class="vr opacity-25"></div>
                    <div class="flex-grow-1">
                      <div class="fw-bold text-dark text-xs">{{ item.description }}</div>
                      <div v-if="item.speaker" class="text-muted text-xxs">{{ item.speaker }}</div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
            <!--Speakers Cards-->
            <div class="card rounded p-3 mt-2 shadow-sm" v-if="this.event?.speakers.length">
              <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
                <div class="fw-bold text-dark">
                  <i class="bi bi-people text-secondary"></i>
                  Speakers
                </div>
                <div class="d-flex align-items-center gap-2">
                  <span class="badge rounded-pill bg-light text-dark">{{ event?.speakers.length }} added</span>
                  <button
                    v-if="event?.speakers.length > 4"
                    class="btn btn-sm btn-primary text-xxs rounded px-3 py-1"
                    type="button"
                    @click="open_event_speakers(event)">
                    See more
                  </button>
                </div>
              </div>

              <div class="row g-3">
                <div
                  v-for="speaker in event?.speakers?.slice(0, 4)"
                  :key="speaker.id"
                  class="col-12 col-md-6"
                >
                  <div class="d-flex align-items-center bg-light rounded-3 p-3 h-100 gap-2">
                    <div class="d-flex align-items-center justify-content-center bg-gradient text-danger flex-shrink-0 overflow-hidden text-uppercase fw-bold circular-progress-svg rounded rounded-circle" >
                      <img
                        v-if="speaker?.speaker_files?.[0]?.file?.file_url"
                        :src="speaker?.speaker_files?.[0]?.file?.file_url"
                        :alt="speaker?.first_name + ' ' + speaker?.last_name"
                        class="rounded-circle w-100 h-100 object-fit-cover"
                      />
                      <span v-else class="text-primary">{{ get_speaker_initials(speaker) }}</span>
                    </div>

                    <div class="d-flex flex-column">
                      <span class="fw-bold text-primary lh-sm text-xs">
                        {{ speaker?.first_name + ' ' + speaker?.last_name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <!-- Materials Cards -->
          <div class="card rounded p-3 mt-2 shadow-sm" v-if="materials_list.length">
            <div class=" d-flex align-items-center justify-content-between gap-2 mb-2">
              <div class="d-flex align-items-center gap-2 fw-bold text-dark">
                  <i class="bi bi-file-earmark-text text-secondary"></i>
                  Materials
                </div>
                <div class="materials-actions d-flex align-items-center gap-2">
                  <span class="badge rounded-pill bg-light text-dark">{{ materials_count }} files</span>
                  <button
                    v-if="has_more_materials"
                    class="btn btn-sm btn-primary text-xxs rounded px-3 py-1"
                    @click="open_document_upload(event)"
                  >
                    See more
                  </button>
                </div>
              </div>
              <div class="row g-3">
            <div v-for="item in materials_preview" :key="item.id" class="col-12 col-md-6">
              <div class="d-flex align-items-center bg-light rounded-3 p-3 h-100 gap-2">
                <img
                  :src="get_icon_class(item)"
                  class="flex-shrink-0 bg-white border p-1 object-fit-contain circular-progress-svg"
                />

                <div class="flex-grow-1 overflow-hidden">
                  <div class="fw-bold text-truncate text-xs">{{ get_file_name(item) }}
                  </div>
                  <div class="fw-bold text-uppercase text-secondary mt-1 text-xxxs">
                  {{ get_file_type_label(item) }}
                  </div>
                </div>

                <div class="d-flex gap-2 ms-auto">
                  <button class="btn btn-sm btn-white border shadow-sm px-2 py-1" @click="open_preview(item)">
                    <i class="bi bi-eye"></i>
                  </button>
                  <button class="btn btn-sm btn-white border shadow-sm px-2 py-1"@click="download_document(item)">
                    <i class="bi bi-download"></i>
                  </button>
                </div>

              </div>
            </div>
            </div>
          </div>
          <!-- Event Gallery -->
          <div class="card rounded p-3 mt-2 shadow-sm" v-if="gallery_preview.length">
            <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
              <div class="d-flex align-items-center gap-2 fw-bold text-dark">
                <i class="bi bi-images text-secondary"></i>
                Event gallery
              </div>
              <div class="d-flex align-items-center gap-2">
                <button
                  v-if="has_more_gallery"
                  class="btn btn-sm btn-primary text-xxs rounded px-3 py-1"
                  type="button"
                  @click="open_media_gallery(event)"
                >
                  See more
                </button>
              </div>
            </div>
            <div class="row g-2">
              <div v-for="(item, index) in gallery_preview" :key="item.id" class="col-6 col-md-3">
                <div
                  class="position-relative rounded-3 overflow-hidden border cursor-pointer gallery-item-wrapper"
                  @click="open_media_gallery(event)"
                >
                  <img v-if="get_event_media_type(item) === 'image'" :src="item.file.file_url" class="w-100 h-100 object-fit-cover" />
                  <video v-else-if="get_event_media_type(item) === 'video'" :src="item.file.file_url" class="w-100 h-100 object-fit-cover" muted></video>
                  <div v-else-if="get_event_media_type(item) === 'audio'" class="w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-light text-primary text-center px-2">
                    <i class="bi bi-music-note-beamed fs-1"></i>
                    <span class="text-xxxs">Audio</span>
                  </div>
                  <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center bg-light text-muted text-xxs">
                    Unsupported
                  </div>
                  <div
                    v-if="index === 3 && get_event_media_files(event).length > 4"
                    class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center event-gallery-blury"
                  >
                    <span class="text-white fw-bold">+{{ get_event_media_files(event).length - 3 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Map Card-->
           <div class="card rounded p-3 mt-2 shadow-sm" v-if="event?.event_type?.name !== 'online' && map_embed_url">
                <div class="d-flex align-items-center gap-2 mb-3">
                  <div class="">
                    <i class="bi bi-geo text-secondary"></i>
                  </div>
                  <div class="fw-bold text-dark">Map</div>
                </div>
                <div class="map-card mt-3 rounded location-map">
                  <iframe
                    :src="map_embed_url"
                    class="map-frame w-100 h-100 border-0 d-block"
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
        </div>
          <div class="col-lg-4 order-0 order-lg-1">
            <div class="card rounded p-3 shadow-sm mb-2" v-if="event?.sponsors?.length">
            <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
              <div class="fw-bold text-dark text-xxs text-uppercase">
                Brands Sponsoring
              </div>
            </div>

            <div class="position-relative">
              <button
                v-if="show_sponsor_scroll_left"
                type="button"
                class="btn position-absolute top-50 start-0 translate-middle-y p-0 border-0 bg-transparent sponsor-card-index"
                @click="scroll_sponsors(-1)"
                aria-label="Scroll sponsors left"
              >
                <i class="bi bi-chevron-left fs-4 text-secondary"></i>
              </button>
              <button
                v-if="show_sponsor_scroll_right"
                type="button"
                class="btn position-absolute top-50 end-0 translate-middle-y p-0 border-0 bg-transparent sponsor-card-index"
                @click="scroll_sponsors(1)"
                aria-label="Scroll sponsors right"
              >
                <i class="bi bi-chevron-right fs-4 text-secondary"></i>
              </button>

              <div
                ref="sponsorScroll"
                class="d-flex gap-3 overflow-auto pb-1 px-4"
                @scroll="update_sponsor_scroll_controls"
              >
              <div
                v-for="sponsor in event?.sponsors"
                :key="sponsor.id || sponsor.name"
                class="flex-shrink-0 sponsor-card"
              >
                <div class="d-flex flex-column align-items-center text-center gap-2">
                  <div class="d-flex align-items-center justify-content-center border rounded-circle bg-light text-uppercase fw-bold overflow-hidden supplier-logo">
                    <img
                      v-if="get_sponsor_logo(sponsor)"
                      :src="get_sponsor_logo(sponsor)"
                      :alt="sponsor?.name"
                      class="w-100 h-100 object-fit-cover rounded-circle"
                    />
                    <span v-else class="text-primary text-xxs">{{ get_sponsor_initials(sponsor) }}</span>
                  </div>
                  <div class="fw-bold text-xxs text-dark text-truncate w-100">{{ sponsor?.name }}</div>
                  <a
                    v-if="sponsor?.website_url"
                    :href="format_sponsor_url(sponsor.website_url)"
                    target="_blank"
                    class="text-xxs rounded"
                                      >
                    Visit site
                    </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Surveys Card -->
          <div class="card event-survey-experience admin rounded-4 shadow-sm mb-2 border-0 overflow-hidden" v-if="can_edit && event_survey">
            <div class="p-3 p-md-4 border-bottom">
              <div class="row g-3 align-items-start">
                <div class="col-12 col-md">
                  <div class="badge badge-portal d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill fw-bold text-uppercase small">
                    <i class="bi bi-kanban"></i>
                    Survey control
                  </div>
                  <div class="d-flex flex-column flex-md-row align-items-start justify-content-between gap-3 mt-3">
                    <h4 class="mb-0 fw-bolder text-dark">Event Survey Manager</h4>
                    <div class="d-flex flex-column flex-sm-row justify-content-md-end gap-2 gap-sm-3">
                  <div>
                    <div class="bg-white border rounded-5 px-4 py-3 h-100">
                      <span class="d-block text-uppercase text-secondary-emphasis small text-nowrap fw-bold">Surveys</span>
                      <span class="d-block mt-1 fs-5 fw-bolder text-dark">{{ event_surveys.length }}</span>
                    </div>
                  </div>
                  <div>
                    <div class="bg-white border rounded-5 px-4 py-3 h-100">
                      <span class="d-block text-uppercase text-secondary-emphasis small text-nowrap fw-bold text-sm">Responses</span>
                      <span class="d-block mt-1 fs-5 fw-bolder text-dark">{{ get_creator_survey_response_count(event_survey) }}</span>
                    </div>
                  </div>
                </div>
                </div>
                  <p class="mt-2 mb-0 text-muted small lh-lg">
                    Review your event survey, inspect response quality, and refine questions without leaving the event page.
                  </p>
                </div>
              </div>
            </div>

            <div class="p-0 pt-0">
            <div v-if="!event_surveys.length" class="bg-light rounded-4 p-4 text-center">
              <i class="bi bi-clipboard-check fs-2 text-secondary"></i>
              <div class="fw-bold text-muted mt-2">No surveys yet</div>
              <div class="text-xxs text-muted">
                Create a survey to gather feedback from attendees
              </div>
            </div>
              <div v-else class="d-flex flex-column gap-3">
              <div v-for="survey in event_surveys" :key="survey.id" class="bg-light bg-gradient border rounded shadow-sm p-3">
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-start gap-3">
                  <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center gap-3 mb-2">
                      <span class="task-due-chip  text-primary bg-primary-subtle px-3 py-2">Survey</span>
                      <span class="task-due-chip  text-primary bg-secondary-subtle px-3 py-2">
                        {{ survey.survey_questions?.length || 0 }} questions
                      </span>
                    </div>
                    <div class="fw-bold text-dark mb-2">{{ survey.name }}</div>
                    <div v-if="survey.description" class="text-muted text-xxs lh-lg" v-html="survey.description"></div>
                  </div>
                  <div class="d-flex flex-wrap align-items-center gap-2">
                    <button
                      class="btn btn-sm btn-light rounded px-3 fw-bold border task-due-chip"
                      type="button"
                      @click="toggle_creator_survey_details(survey)"
                    >
                      {{ is_creator_survey_expanded(survey) ? 'Hide details' : 'View details' }}
                    </button>
                    <button
                      class="btn btn-sm btn-primary text-white rounded px-3 fw-bold task-due-chip"
                      type="button"
                      @click="open_edit_survey(survey)"
                    >
                      Edit
                    </button>
                    <button
                      class="btn btn-danger btn-sm rounded px-3 fw-bold task-due-chip bg-danger text-white mt-1"
                      type="button"
                      @click="delete_survey(survey.id)"
                    >
                      Delete
                    </button>
                  </div>
                </div>

                <div class="d-flex flex-wrap gap-2 mt-2">
                  <span class="badge rounded-pill text-primary bg-primary-subtle px-3 py-2">Respondents: {{ get_creator_survey_response_count(survey) }}</span>
                  <span class="badge rounded-pill text-primary bg-primary-subtle px-3 py-2">Questions: {{ survey.survey_questions?.length || 0 }}</span>
                </div>

                <div v-if="is_creator_survey_expanded(survey)" class="d-grid gap-3 mt-3">
                  <div
                    v-for="(question, index) in survey.survey_questions || []"
                    :key="question.id"
                    class="bg-light border rounded-4 p-3"
                  >
                    <div class="d-flex justify-content-between align-items-center gap-3 mb-2">
                      <span class="badge border text-primary bg-primary-subtle px-3 py-2 task-due-chip">Question {{ index + 1 }}</span>
                      <span class="badge border text-dark bg-secondary-subtle px-3 py-2 task-due-chip">
                        {{ get_event_survey_question_type_label(question.question.question_type.question_type) }}
                      </span>
                    </div>
                    <div class="fw-bold text-dark lh-base">{{ question.question.question }}</div>

                    <div class="d-flex flex-wrap gap-2 mt-2">
                      <span class="badge rounded-pill text-primary bg-primary-subtle px-3 py-2">Responses: {{ get_creator_survey_question_response_count(question) }}</span>
                      <span v-if="question.question.is_mandatory" class="badge rounded-pill text-danger bg-danger-subtle px-3 py-2">Required</span>
                    </div>

                    <div v-if="question.question.options?.length" class="d-flex flex-wrap gap-2 mt-3">
                      <span
                        v-for="opt in question.question.options"
                        :key="opt.id"
                        class="badge rounded-pill text-secondary bg-secondary-subtle px-3 py-2"
                      >
                        {{ opt.option }}
                      </span>
                    </div>

                    <div v-if="question.answers?.length" class="d-flex flex-column gap-2 mt-3">
                      <div
                        v-for="(response, responseIndex) in question.answers"
                        :key="responseIndex"
                        class="bg-white border rounded-4 px-3 py-2 text-muted small lh-base"
                      >
                        <strong v-if="response.user?.is_blocked">Unknown User</strong>
                        <strong v-else>{{ response.user?.first_name }} {{ response.user?.last_name }}</strong>
                        <span class="text-muted">:</span>
                        {{ response.answer || '-' }}
                      </div>
                    </div>

                    <div v-else class="text-secondary-emphasis small fst-italic mt-3">
                      No responses yet.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
          <!-- Event Survey (Attendees) -->
          <div class="card event-survey-experience attendee rounded-4 shadow-sm mb-2 border-0 overflow-hidden" v-if="!can_edit && event_survey && token_exists">
            <div class="p-3 p-md-4 border-bottom">
              <div class="row g-3 align-items-start">
                <div class="col-12 col-md">
                  <div class="badge badge-portal d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill fw-bold text-uppercase small">
                    <i class="bi bi-stars"></i>
                    {{ event_survey?.is_answered ? 'Event feedback · submitted' : 'Event feedback '  }}
                  </div>
                  <div class="d-flex flex-column flex-md-row align-items-start justify-content-between gap-3 mt-3">
                    <h4 class="mb-0 fw-bolder text-dark">{{ event_survey?.name || 'Survey' }}</h4>
                    <div class="d-flex flex-row justify-content-md-end gap-2 gap-sm-3 w-100">
                  <div class="flex-fill">
                    <div class="bg-white border rounded-5 px-3 px-sm-4 py-3 h-100">
                      <span class="d-block text-uppercase text-secondary-emphasis fw-semibold text-nowrap" >Questions</span>
                      <span class="d-block mt-1 fs-5 fw-bolder text-dark">{{ event_survey_total_questions }}</span>
                    </div>
                  </div>
                  <div class="flex-fill">
                    <div class="bg-white border rounded-5 px-3 px-sm-4 py-3 h-100">
                      <span class="d-block text-uppercase text-secondary-emphasis fw-semibold text-nowrap">{{ event_survey?.is_answered ? 'Status' : 'Progress' }}</span>
                      <span class="d-block mt-1 fs-5 fw-bolder text-dark">
                      {{ event_survey?.is_answered ? 'Done' : event_survey_completion_percent + '%' }}
                      </span>
                    </div>
                  </div>
                </div>
                </div>
                  <p v-if="event_survey?.description" class="mt-2 mb-0 text-muted small lh-lg" v-html="event_survey.description"></p>
                  <p v-else class="mt-2 mb-0 text-muted small lh-lg">
                    Tell us what worked, what stood out, and what would make the next event even better.
                  </p>
                </div>
              </div>

              <div class="d-flex flex-row align-items-center justify-content-between gap-2 gap-sm-3 mt-3 flex-wrap">
                <span v-if="event_survey?.is_answered" class="badge rounded-pill text-success bg-success-subtle px-3 py-2 align-self-start">Feedback submitted</span>

                <button
                  v-if="event_survey?.is_answered && !show_event_survey_answers"
                  class="btn btn-light rounded px-3 fw-bold"
                  type="button"
                  @click="open_event_survey_answers"
                >
                  View answers
                </button>
                <button
                  v-if="!event_survey?.is_answered && !show_event_survey_form"
                  class="btn btn-sm btn-primary rounded px-3 fw-bold"
                  type="button"
                  @click="open_event_survey_form"
                >
                  Start survey
                </button>
              </div>

              <div v-if="!event_survey?.is_answered && show_event_survey_form" class="mt-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <span class="text-uppercase text-muted small fw-bold">Completion</span>
                  <span class="text-uppercase text-muted small fw-bold">{{ event_survey_answered_count }}/{{ event_survey_total_questions }}</span>
                </div>
                
              </div>
            </div>

            <div v-if="event_survey?.is_answered && show_event_survey_answers" class="p-4 overflow-auto">
              <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-start gap-3 mb-3">
                <div>
                  <div class="text-uppercase text-secondary small fw-bold">Your response</div>
                  <h4 class="mt-1 mb-0 fw-bolder text-dark">Thanks for sharing your feedback</h4>
                </div>
                <button class="btn btn-outline-secondary btn-sm rounded- px-3" type="button" @click="close_event_survey_answers">
                  Hide
                </button>
              </div>

              <div class="d-grid gap-3">
                <div v-for="(question, index) in event_survey_questions" :key="question.id" class="bg-light bg-gradient border rounded-4 shadow-sm p-3">
                  <div class="d-flex justify-content-between align-items-center gap-3 mb-3">
                    <span class="task-due-chip rounded text-primary  px-3 py-2">Question {{ index + 1 }}</span>
                    <span class="task-due-chip rounded text-secondary  px-3 py-2">
                      {{ get_event_survey_question_type_label(question.question.question_type.question_type) }}
                    </span>
                  </div>
                  <div class="fw-bold text-dark mb-3 lh-base">{{ question.question.question }}</div>

                  <div v-if="question.question.question_type.question_type === 'checkbox'" class="d-flex flex-wrap gap-2">
                    <span
                      v-for="(answer, answerIndex) in get_event_survey_display_answers(question)"
                      :key="question.id + '_ans_' + answerIndex"
                      class="badge rounded text-primary bg-primary-subtle px-3 py-2"
                    >
                      {{ answer }}
                    </span>
                    <span v-if="!get_event_survey_display_answers(question).length" class="text-secondary-emphasis small fst-italic">No answer submitted</span>
                  </div>

                  <div v-else class="bg-light border rounded-4 px-3 py-3 text-muted small lh-lg">
                    {{ question.answers?.[0]?.answer || 'No answer submitted' }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="show_event_survey_form && !event_survey?.is_answered" class="p-4 overflow-auto">
              <div class="mb-3">
                <div>
                  <div class="text-uppercase text-secondary small fw-bold">Share your experience</div>
                  <h5 class="mt-1 mb-0 fw-bolder text-dark">Help shape the next event</h5>
                </div>
              </div>

              <div class="d-grid gap-3 rounded">
                <div
                  v-for="(question, index) in event_survey_questions"
                  :key="question.id"
                  class="bg-light border rounded shadow-sm p-3"
                  :class="{ 'border-danger-subtle': has_event_survey_error(question.question.id) }"
                >
                  <div class="d-flex justify-content-between align-items-center gap-3 mb-3">
                    <span class="task-due-chip">Question{{ index + 1 }}</span>
                  </div>
                  <div class="fw-bold text-dark mb-3 lh-base">{{ question.question.question }}</div>

                  <div v-if="question.question.question_type.question_type === 'yes_no'" class="row g-3 row-cols-1 row-cols-md-2">
                    <label v-for="opt in ['Yes', 'No']" :key="opt" class="col">
                      <span class="d-flex align-items-center gap-3 px-3 py-3 rounded bg-light border w-100" :class="{ 'border-primary bg-primary-subtle': event_survey_answers[question.question.id] === opt }">
                      <input
                        type="radio"
                        class="form-check-input"
                        :name="'question_' + question.question.id"
                        :value="opt"
                        :checked="event_survey_answers[question.question.id] === opt"
                        @change="set_event_survey_answer(question.question.id, opt)"
                      />
                      <span>{{ opt }}</span>
                      </span>
                    </label>
                  </div>

                  <div v-else-if="question.question.question_type.question_type === 'multiple_choice'" class="d-flex flex-column gap-3">
                    <label v-for="opt in question.question.options || []" :key="opt.id" class="d-flex align-items-center gap-3 px-3 py-3 rounded-4 bg-light border">
                      <input
                        type="radio"
                        class="form-check-input"
                        :name="'q' + question.question.id"
                        :value="opt.option"
                        :checked="event_survey_answers[question.question.id] === opt.option"
                        @change="set_event_survey_answer(question.question.id, opt.option)"
                      />
                      <span>{{ opt.option }}</span>
                    </label>
                  </div>

                  <select
                    v-else-if="question.question.question_type.question_type === 'selection'"
                    class="form-select rounded"
                    :value="event_survey_answers[question.question.id] || ''"
                    @change="set_event_survey_answer(question.question.id, $event.target.value)"
                  >
                    <option value="" disabled>Select an option</option>
                    <option v-for="option in question.question.options || []" :key="option.id" :value="option.option">
                      {{ option.option }}
                    </option>
                  </select>

                  <div v-else-if="question.question.question_type.question_type === 'checkbox'" class="d-flex flex-column gap-3">
                    <label v-for="option in question.question.options || []" :key="option.id" class="d-flex align-items-center gap-3 px-3 py-3 rounded-4 bg-light border">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :checked="(event_survey_answers[question.question.id] || []).includes(option.option)"
                        @change="toggle_event_survey_checkbox_answer(question.question.id, option.option, $event.target.checked)"
                      />
                      <span>{{ option.option }}</span>
                    </label>
                  </div>

                  <textarea
                    v-else-if="question.question.question_type.question_type === 'text' || question.question.question_type.question_type === 'paragraph' || question.question.question_type.question_type === 'text_area'"
                    class="form-control rounded"
                    :placeholder="question.question.question"
                    :value="event_survey_answers[question.question.id] || ''"
                    rows="4"
                    @input="set_event_survey_answer(question.question.id, $event.target.value)"
                  ></textarea>

                  <div v-else-if="question.question.question_type.question_type === 'number'">
                    <input
                      type="number"
                      class="form-control rounded"
                      :value="event_survey_answers[question.question.id] || ''"
                      :placeholder="question.question.question"
                      @input="set_event_survey_answer(question.question.id, $event.target.value); validate_event_survey_number(question.question.id)"
                    />
                    <p v-if="event_survey_number_errors[question.question.id]" class="text-danger small mt-2 mb-0">
                      {{ event_survey_number_errors[question.question.id] }}
                    </p>
                  </div>

                  <input
                    v-else-if="question.question.question_type.question_type === 'date'"
                    type="date"
                    class="form-control rounded"
                    :value="event_survey_answers[question.question.id] || ''"
                    @input="set_event_survey_answer(question.question.id, $event.target.value)"
                  />

                  <input
                    v-else-if="question.question.question_type.question_type === 'link'"
                    type="url"
                    class="form-control rounded"
                    placeholder="https://"
                    :value="event_survey_answers[question.question.id] || ''"
                    @input="set_event_survey_answer(question.question.id, $event.target.value)"
                  />

                  <p v-if="has_event_survey_error(question.question.id)" class="text-danger small mt-2 mb-0">
                    {{ get_event_survey_error(question.question.id) }}
                  </p>
                </div>
              </div>

              <div class="d-flex flex-column flex-md-row align-items-md-center gap-3 mt-3 pt-3 border-top">
            <div class="text-muted small">
              Your feedback helps us improve future sessions, content, and event flow.
            </div>

            <div class="d-flex gap-2 flex-shrink-0 ms-md-auto">
              <button
                class="btn btn-sm btn-primary rounded-pill px-3"
                type="button"
                @click="submit_event_survey_answers"
              >
                Submit
              </button>

              <button
                class="btn btn-sm btn-outline-secondary rounded-pill px-3"
                type="button"
                @click="close_event_survey_form"
              >
                Cancel
              </button>
            </div>
          </div>
            </div>
            </div>
              <div v-if="event_cover_image" class="card rounded p-2 shadow-sm mb-2 overflow-hidden">
                <div class="event-view-sidebar-cover rounded overflow-hidden">
                  <img
                    :src="event_cover_image"
                    alt="Event cover"
                    class="event-view-sidebar-cover-image"
                  />
                </div>
              </div>
              <div v-if="can_edit" class="card rounded p-3 shadow-sm">
              <div class="text-xxs text-uppercase text-primary fw-bold">Total registrations</div>
              <div class="display-6 fw-bolder text-dark lh-1 mt-2">{{ total_registrations }}</div>
              <div class="text-xxs text-muted mt-2">{{ capacity_text }}</div>

            <div class="progress mt-2">
              <div
                class="progress-bar bg-danger"
                role="progressbar"
                :style="{ width: capacity_percent + '%' }"
                :aria-valuenow="capacity_percent"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>

            <div class="mt-3">
              <div v-if="ticket_breakdown.length" class="border-top pt-3">
                <div
                  v-for="(item, index) in ticket_breakdown"
                  :key="index"
                  class="d-flex align-items-center justify-content-between py-2"
                  :class="{ 'border-top': index !== 0 }"
                >
                  <div>
                    <div class="fw-bold text-dark text-xs">{{ item.value }}</div>
                    <div class="text-xxs text-danger fw-semibold text-uppercase">{{ item.label }}</div>
                    <div class="text-xxxs text-muted">{{ item.sublabel }}</div>
                  </div>
                </div>
              </div>
            </div>
          <div class="mt-3 d-flex gap-2">
            <button
              v-if="can_edit"
              class="btn btn-primary text-xxs fw-bold flex-fill"
              type="button"
              @click="view_attendees"
            >
              <i class="bi bi-people me-1"></i>
              View attendees
            </button>
            <button
              v-if="can_edit"
              class="btn btn-primary text-xxs fw-bold flex-fill"
              type="button"
              @click="start_scanning(event?.id)"
            >
                  <i class="bi bi-qr-code-scan me-1"></i>
                  Scan Ticket
                </button>
              </div>
            </div>
            <div v-if="show_ticket_rsvp_card" class="card rounded p-3 shadow-sm" :class="{ 'mt-3': show_ticket_rsvp_card && can_edit }">
              <div class="d-flex align-items-center gap-2 mb-3">
                <div class="d-flex align-items-center justify-content-center rounded-2 text-secondary">
                  <i class="bi" :class="event?.is_free ? 'bi-calendar-check' : 'bi-ticket-perforated'"></i>
                </div>
                <div class="event-details-title text-dark fw-bold">{{ event?.is_free ? 'RSVP' : 'Available tickets' }}</div>
              </div>
              <div v-if="event?.is_free" class="text-xxs text-muted mb-2">
                {{ capacity_value ? (Math.max(0, capacity_value - total_registrations) + ' spots left') : 'Capacity is maximum' }}
              </div>
              <div v-if="event_tickets.length > 0" class="d-flex flex-column gap-3">
                <div v-for="ticket in event_tickets" :key="ticket.id" class="border rounded-3 p-3">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="fw-bold text-dark">{{ ticket?.ticket?.name || 'Ticket' }}</div>
                    <div class="fw-bold text-dark">{{ Number(ticket?.price || 0) === 0 ? 'Free' : 'R' + ticket?.price }}</div>
                  </div>
                  <div class="text-xxs text-muted mt-1" v-if="ticket.available_instances > 0">{{ ticket.available_instances }} left</div>
                  <div class="text-xxs text-danger mt-1 fw-semibold" v-else>Sold out</div>
                </div>
              </div>
              <div v-else-if="!event?.is_free" class="text-xxs text-muted">No tickets available for this event.</div>

              <button
                v-if="!event?.is_free && event_tickets.length > 0"
                class="btn btn-primary w-100 mt-3 text-xxs fw-bold"
                type="button"
                @click="handle_rsvp(event)"
              >
                <i class="bi bi-cart3 me-2"></i>
                Buy tickets
              </button>

              <button
                v-else-if="event?.is_free && event?.is_rsvped"
                class="btn btn-danger w-100 mt-3 text-xxs fw-bold"
                type="button"
                @click="cancel_rsvp(event.id)"
              >
                Cancel RSVP
              </button>

              <button
                v-else-if="event?.is_free && rsvp_button(event)"
                class="btn btn-primary w-100 mt-3 text-xxs fw-bold"
                type="button"
                @click="handle_rsvp(event)"
              >
                <i class="bi bi-cart3 me-2"></i>
                RSVP Now
              </button>

              <button
                v-else-if="event?.is_free && event?.is_waitlisted"
                class="btn btn-primary w-100 mt-3 text-xxs fw-bold"
                type="button"
                disabled
              >
                On Waiting List
              </button>

              <button
                v-else-if="event?.is_free"
                class="btn btn-primary w-100 mt-3 text-xxs fw-bold"
                type="button"
                @click="handle_rsvp(event)"
              >
                <i class="bi bi-cart3 me-2"></i>
                Join Waiting List
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<EventMediaGallery
  ref="eventMediaGalleryRef"
  :event_id="event_id"
  @media-updated="update_parent_event_files"
  @media-deleted="handle_parent_file_deletion"
  @pin-changed="handle_pin_update"
/>
<EventResource
  ref="eventResourceRef"
  :event_id="event_id"
  @documents-updated="update_parent_event_files"
  @document-deleted="handle_parent_file_deletion"
/>
<PromoCode
  ref="promoCodeRef"
  :event_id="event_id"
/>
<EventAgenda
  ref="eventAgendaRef"
  :event_id="event_id"
  @agenda-updated="update_parent_agenda"
/>

<teleport to="body">
  <div class="modal fade" id="rsvp_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 shadow rounded-3 bg-light">
        <div class="modal-header bg-primary d-flex align-items-center">
          <i class="bi bi-ticket-perforated-fill text-white fs-3 me-2"></i>
          <h5 class="modal-title fw-bold mb-0 fs-3 text-white" id="exampleModalLabel">RSVP</h5>
          <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" @click="add_rsvp"></button>
        </div>

        <form @submit.prevent="add_rsvp">
          <div class="modal-body overflow-auto modal-scroll">
            <div v-if="cbo_domain" class="mb-3">
              <label for="business_name" class="form-label fw-semibold small text-secondary">Provide business name</label>
              <input type="text" v-model="business_name" placeholder="Business Name" class="form-control rounded">
            </div>

            <div v-if="cbo_domain" class="mb-3">
              <label for="firstTimeSelect" class="form-label fw-semibold small text-secondary">Is this your first time attending?</label>
              <select v-model="is_first_time" class="form-select rounded" id="firstTimeSelect">
                <option disabled value="">Please select an option</option>
                <option :value="true">Yes</option>
                <option :value="false">No</option>
              </select>
            </div>

            <div v-if="cbo_domain" class="mb-4">
              <label for="chapterSelect" class="form-label fw-semibold small text-secondary">Home Chapter</label>
              <select v-model="chapter" class="form-select rounded" id="chapterSelect">
                <option disabled value="">Please select a chapter</option>
                <option v-for="chapter in chapters" :key="chapter" :value="chapter">{{ chapter }}</option>
              </select>
            </div>

            <div v-if="event_extras.length > 0" class="border-top mb-4 pt-4"></div>

            <div v-for="extra in event_extras" :key="extra.id" class="mb-4">
              <div class="d-flex align-items-center gap-2 mb-3">
                <i class="bi bi-star text-secondary fs-6"></i>
                <label class="form-label text-uppercase fw-bold mb-0 small text-primary">{{ extra.extra.name }}</label>
              </div>

              <div class="d-flex flex-column gap-2">
                <div
                  v-for="item in extra.items"
                  :key="item.id"
                  class="border rounded p-3 d-flex align-items-center gap-3 cursor-pointer transition-all"
                  :class="{
                    'border-primary bg-light shadow-sm': selected_item_id.includes(item.id),
                    'bg-white': !selected_item_id.includes(item.id)
                  }"
                  @click="toggle_item(item.id)"
                >
                  <input
                    class="form-check-input mt-0 me-3"
                    type="checkbox"
                    :id="'item_' + item.id"
                    :value="item.id"
                    v-model="selected_item_id"
                    @click.stop="toggle_item(item.id)"
                  >
                  <div class="flex-grow-1 d-flex justify-content-between align-items-center">
                    <div>
                      <div class="fw-semibold">{{ item.item_name }}</div>
                      <div class="text-muted small">{{ item.description }}</div>
                    </div>
                    <div v-if="!workbook_domain" class="fw-bold text-primary small">R{{ item.price }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer border-top py-3 bg-light">
            <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="event_extras.length > 0 && !selected_item_id.length">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="scanModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary ">
          <h5 class="modal-title text-white">Scan Ticket</h5>
          <button type="button" class="btn-close bg-light" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body text-center p-3">
          <video id="video"
                v-show="show_camera"
                autoplay playsinline
                class="w-100 rounded shadow-sm"></video>
          <canvas id="canvas" hidden></canvas>

          <div v-if="scan_result_box" class="p-3 rounded text-center"
              :class="{'bg-success text-white': scan_success, 'bg-danger text-white': !scan_success}">
            <h3 class="fw-bold mb-2">
              {{ scan_success ? '✔ Ticket Validated' : '✖ Ticket Error' }}
            </h3>
            <div class="d-flex justify-content-center">
              <p v-if="scan_success" class="mt-3 text-start">
                <strong>Ticket ID:</strong> {{ scan_data.ticket_id }} <br>
                <strong>Event:</strong> {{ scan_data.event }} <br>
                <strong>Ticket Type:</strong> {{ scan_data.ticket_type }}
              </p>
              <p v-else>{{ scan_error_message }}</p>
            </div>
            <button class="btn btn-primary mt-3 rounded fw-bold shadow" @click="restart_scan">
              Scan Again
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="ticket_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500">{{ selected_event?.event_name }}</p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>

        <div class="modal-body">
          <div class="text-start mb-3">
            <p class="mb-1 text-xxs text-muted">
              <i class="bi bi-calendar-event"></i>
              {{ format_date(selected_event?.start_date) }}
            </p>
            <p class="mb-1 text-xxs text-muted" v-if="selected_event?.location">
              <i class="bi bi-geo-alt"></i>
              {{ selected_event.location }}
            </p>
            <span class="badge bg-light text-xxs rounded text-dark border rounded-pill" v-if="!selected_event?.is_free">
              Paid Event
            </span>
          </div>

          <p class="text-xxs">Select Tickets</p>
          <div v-if="event_tickets.length === 0" class="text-center py-4">
            <p class="text-muted text-xxs">No available tickets for this event.</p>
          </div>

          <div v-else>
            <div v-for="ticket in event_tickets" :key="ticket.id"
                class="d-flex justify-content-between align-items-center border-0 shadow-sm bg-light p-2 mb-2">
              <div class="text-start">
                <div class="fw-500">
                  {{ ticket?.ticket?.name }}
                  <span v-if="ticket.is_sold_out" class="badge bg-danger text-xxs rounded ms-2">Sold Out</span>
                </div>
                <div class="text-success fw-bold">
                  R{{ ticket?.price }}
                </div>
                <small class="text-muted" v-if="ticket.available_instances > 0">
                  Available: {{ ticket.available_instances - ticket.quantitySelected }}
                </small>
              </div>

              <div v-if="validate_ticket_date(ticket?.start_date)" class="d-inline-flex align-items-center border rounded px-2">
                <button class="btn btn-sm text-xxs rounded border-0 shadow-0 px-2"
                        @click="ticket.quantitySelected = Math.max(0, ticket.quantitySelected - 1)">
                  -
                </button>
                <span class="px-3">{{ ticket?.quantitySelected }}</span>
                <button class="btn btn-sm text-xxs rounded border-0 shadow-0 px-2"
                        @click="ticket.quantitySelected = Math.min(ticket.available_instances, ticket.quantitySelected + 1)">
                  +
                </button>
              </div>
              <div v-else>
                <span class="badge rounded-pill bg-primary px-3 py-2 fw-light text-uppercase shadow-sm">Coming Soon</span>
              </div>
            </div>
          </div>

          <div class="promo-section-modal">
            <div>
              <div class="d-flex align-items-center mb-2">
                <label class="text-muted text-xs mb-0 me-1">Have a promo code?</label>
                <i class="bi bi-question-circle-fill text-muted cursor-pointer text-xxs"></i>
              </div>

              <div class="d-flex gap-2">
                <div class="flex-grow-1">
                  <input
                    type="text"
                    v-model="promo_input"
                    class="form-control rounded text-xxs"
                    placeholder="Enter promo code"
                    :disabled="is_applying"
                  />
                </div>
                <button
                  class="btn btn-primary btn-sm text-xxs rounded px-4"
                  type="button"
                  :disabled="!promo_input || is_applying"
                  @click="apply_promo"
                >
                  <span v-if="is_applying" class="spinner-border spinner-border-sm me-1"></span>
                  Apply code
                </button>
              </div>

              <transition name="fade">
                <p v-if="promo_message" :class="['text-xs mt-2 mb-0', promo_status === 'success' ? 'text-success' : 'text-danger']">
                  {{ promo_message }}
                </p>
              </transition>

              <div class="mt-2 text-end">
                <div v-if="applied_promo" class="text-success text-xxs mb-1">
                  <i class="bi bi-tag-fill"></i>
                  Applied:
                  {{ applied_promo?.promo_code.promo_code_type?.name === 'percentage' ? applied_promo?.promo_code.discount_amount + '%' : 'R' + applied_promo?.promo_code.discount_amount }} off
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-between align-items-center border-0">
          <p class="fw-bold text-xxs mb-0">Total: R{{ calculate_total() }}</p>
          <button class="btn btn-primary btn-sm text-xxs rounded px-4" @click="process_to_checkout":disabled="!event_tickets || event_tickets.length === 0"> Proceed To Checkout</button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
<div class="modal fade" id="availablePromosModal" tabindex="-1" aria-labelledby="availablePromosModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded shadow scrollable-container">
      <div class="modal-header bg-primary position-relative">
        <div class="d-flex align-items-center gap-2">
          <h5 class="modal-title text-white" id="availablePromosModalLabel">
            Available Promo
          </h5>
        </div>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body table-responsive">
        <p class="text-muted mb-4 text-xxs">
          Select a promo code below to copy and use at checkout
        </p>

        <div class="d-flex flex-column gap-3">
          <div
            class="promo-item p-3 border rounded-2 cursor-pointer"
            @click.stop="select_promo(event?.promo_codes[0]?.promo_code_name)"
          >
            <div class="d-flex align-items-center justify-content-between gap-2">
              <div class="d-flex align-items-center gap-3 flex-grow-1">
                <div class="d-flex align-items-center justify-content-center flex-shrink-0 rounded-3 text-white bg-primary rounded icon-box">
                  <i class="bi bi-tag-fill"></i>
                </div>
                <div>
                  <div class="fw-bold text-dark text-xxss">{{ event?.promo_codes[0]?.promo_code_name }}</div>
                   {{ event?.promo_codes[0]?.promo_code.promo_code_type?.name === 'percentage' ? event?.promo_codes[0]?.promo_code.discount_amount + '%' : 'R' + event?.promo_codes[0]?.promo_code.discount_amount }} off
                </div>
              </div>
              <i class="bi bi-copy text-bg-primary flex-shrink-0"></i>
            </div>
          </div>
        </div>
         <div aria-live="polite" aria-atomic="true" class="position-fixed custom-toast">
        <div id="copyToast" class="toast align-items-center text-bg-success border-0" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="d-flex">
              <div class="toast-body">
                Link copied to clipboard!
              </div>
              <button type="button" class="btn-close btn-close-white me-2 m-auto"
                data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title me-auto" id="exampleModalLabel">Attendees for this event</h5>
          <div class="d-flex align-items-center">
            <button
              v-if="(user_details.user_role==='admin' || String(event?.user?.id) === String(get_user_id())) && token_exists"
              class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 ms-2 justify-content-end me-3"
              @click="export_to_csv(selected_event)"
            >
              Export RSVP
            </button>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
        <div class="modal-body table-responsive">
          <table class="table table-striped text-xxs">
            <thead class="text-uppercase btn-primary text-white sticky-top">
              <tr>
                <th class="fw-light">First Name</th>
                <th class="fw-light">Last Name</th>
                <th class="fw-light">Email</th>
                <th class="fw-light">Phone Number</th>
                <th v-if="cbo_domain" class="fw-light">Business Name</th>
                <th v-if="cbo_domain" class="fw-light">First Time attending?</th>
                <th v-if="cbo_domain" class="fw-light">Chapter</th>
                <th class="fw-light">Meal</th>
                <th class="fw-light">Status</th>
                <th class="fw-light">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in event?.rsvp_list" :key="user.id">
                <td>{{user.user?.first_name}}</td>
                <td>{{user.user?.last_name}}</td>
                <td>{{user.user?.email}}</td>
                <td>{{user.user?.phone_number}}</td>
                <td v-if="cbo_domain">{{user.business_name}}</td>
                <td v-if="cbo_domain">{{user.is_first_time ? 'Yes' : 'No' }}</td>
                <td v-if="cbo_domain">{{user.chapter}}</td>
                <td>
                  <span v-for="extra in user?.rsvp_items">{{extra?.item?.item_name}},</span>
                </td>
                <td>
                  {{user?.rsvp_status?.name}}
                </td>
                <td>
                  <button
                    v-if="!['cancelled', 'waitlisted'].includes(user?.rsvp_status?.name)"
                    class="btn btn-sm rounded btn-danger fw-500 text-xxs"
                    @click="cancel_rsvp(selected_event.id, user.user.id)"
                  >
                    Cancel RSVP
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="event_user_ticket" tabindex="-1" aria-labelledby="eventUserTicketLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="eventUserTicketLabel">Attendees for this event</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body table-responsive">
          <table class="table table-striped text-xxs">
            <thead class="text-uppercase btn-primary text-white sticky-top">
              <tr>
                <th class="fw-light">First Name</th>
                <th class="fw-light">Last Name</th>
                <th class="fw-light">Email</th>
                <th class="fw-light">Ticket Name</th>
                <th class="fw-light">Ticket Code</th>
                <th class="fw-light">Redeemed</th>
                <th class="fw-light">Purchased At</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in event_ticket_attendees" :key="user.id">
                <td>{{user?.first_name}}</td>
                <td>{{user?.last_name}}</td>
                <td>{{user?.email}}</td>
                <td>{{ user?.ticket_name }}</td>
                <td>{{ user?.unique_code }}</td>
                <td>{{ user?.is_redeemed ? 'Yes' : 'No' }}</td>
                <td>{{ new_format_date(user.order_date) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</teleport>

<EventSpeaker ref="eventSpeakerRef" />
<EventSponsor ref="eventSponsorRef" />
<EventSurvey ref="eventSurveyRef" />
